<template>
  <div
    id="jqImg4"
    class="domePrint colorBack"
    v-watermark="{
      text: appMobilePhone,
      textColor: 'rgba(180, 180, 180, 0.3)',
    }"
    :class="{ isChildBackground: inquiryInfo.IsChild }"
  >
    <div class="register colorBack">
      <span>{{ "医疗机构执业许可证登记号：" + inquiryInfo.LicenceNo }}</span>
    </div>
    <div class="title">
      <div class="bianju">
        <!-- <div class="hospitalName colorBack">{{ inquiryInfo.EntityName }}</div> -->
        <div class="hospitalOpen colorBack">{{ inquiryInfo.TitleName }}</div>
      </div>
      <div class="ordinary">
        <div>
          <div class="putong colorBack" v-if="!inquiryInfo.IsChild">普通</div>
          <div class="putong colorBack" v-else>儿童普通</div>
          <div class="colorBack">药品处方</div>
        </div>
      </div>
    </div>
    <div class="payOff colorBack">
      <div class="payOff_item">
        <div class="m-r margin-left titleColor">费别：</div>
        <div class="flex1 m-r" style="width: 100px">
          <div>
            <span class="icon iconfont">&#xe65f;</span>
            <label class="titleColor">公费</label>
            <br />
            <span class="icon iconfont">&#xe65f;</span>
            <label class="titleColor">自费</label>
          </div>
          <div>
            <span class="icon iconfont">&#xe65f;</span>
            <label class="titleColor">医保</label>
            <br />
            <span class="icon iconfont">&#xe65f;</span>
            <label class="titleColor">其他</label>
          </div>
        </div>
      </div>
      <div class="payOff_item">
        <div class="m-r titleColor">
          {{ "卡号：" + inquiryInfo.InquiryId }}
        </div>
        <div class="m-r titleColor">
          {{ "处方编号：" + inquiryInfo.OrderId }}
        </div>
      </div>
    </div>
    <div class="posionInfo posionInfo_space">
      <div class="flex1 margin-left mtb colorBack">
        <div class="widthStr280 flex1 colorBack">
          <div class="lableStr colorBack">姓名：</div>
          <div class="name colorBack">{{ inquiryInfo.Name }}</div>
        </div>
        <div class="flex2 widthStr340 colorBack">
          <div class="m-r lableStr colorBack">
            <span class="colorBack">性别:</span>
            <span class="icon iconfont" v-if="inquiryInfo.Sex == 2"
              >&#xe65f;</span
            >
            <span class="icon iconfont" v-else>&#xe64f;</span>
            <span class="colorBack">男</span>
            <span class="icon iconfont" v-if="inquiryInfo.Sex == 1"
              >&#xe65f;</span
            >
            <span class="icon iconfont" v-else>&#xe64f;</span>
            <span class="colorBack">女</span>
          </div>
          <div class="flex1 widthStr m-r">
            <div class="lableStr colorBack">年龄：</div>
            <div class="age colorBack" style="white-space: nowrap">
              {{ inquiryInfo.AgeStr }}
            </div>
          </div>
          <div class="flex1 widthStr" v-show="inquiryInfo.IsChild">
            <div class="lableStr colorBack">体重：</div>
            <div class="age colorBack" style="white-space: nowrap">
              {{ inquiryInfo.Weight }}
            </div>
          </div>
        </div>
      </div>
      <div class="flex1 margin-left mtb">
        <div class="widthStr280 flex1">
          <div class="lableStr colorBack">问诊/住院病例号：</div>
          <div class="name colorBack" style="font-size: 14px">
            {{ inquiryInfo.InquiryId }}
          </div>
        </div>
        <div class="widthStr340">
          <div class="flex1">
            <div class="lableStr colorBack">科别(病区/床号)：</div>
            <div class="age colorBack">{{ inquiryInfo.Department }}</div>
          </div>
        </div>
      </div>
      <div class="flex1 margin-left mtb">
        <div class="lableStr colorBack">临床诊断：</div>
        <div class="name colorBack">{{ inquiryInfo.Diseases }}</div>
      </div>
      <div class="flex1 margin-left mtb">
        <div class="widthStr280 flex1">
          <div class="lableStr colorBack">肝功能异常：</div>
          <div class="name colorBack">{{ inquiryInfo.RenalType }}</div>
        </div>
        <div class="widthStr340">
          <div class="flex1">
            <div class="lableStr colorBack">肾功能异常：</div>
            <div class="age colorBack">{{ inquiryInfo.LiverType }}</div>
          </div>
        </div>
      </div>
      <div class="flex1 margin-left mtb">
        <div class="widthStr280 flex1">
          <div class="lableStr colorBack">过敏史：</div>
          <div class="name colorBack">{{ inquiryInfo.AMHType }}</div>
        </div>
        <div class="widthStr340 flex1">
          <div class="lableStr colorBack">备孕、妊娠、哺乳：</div>
          <div class="name colorBack">{{ inquiryInfo.AMHType }}</div>
        </div>
      </div>
      <!-- <div class="flex1 margin-left mtb">
        <div class="widthStr flex1">
          <div class="lableStr colorBack">备孕、妊娠、哺乳：</div>
          <div class="name colorBack">{{ inquiryInfo.AMHType }}</div>
        </div>
      </div> -->
    </div>
    <div class="drugInfo">
      <div class="margin-left">
        <div class="rp">RP</div>
        <!-- 西药 -->
        <div v-if="!_deptCode">
          <div v-for="(item, i) in inquiryInfo.DrugsList" :key="i">
            <div class="flex1">
              <div class="colorBack">{{ item.Name }}</div>
              <div class="colorBack">{{ item.Specs }}</div>
              <div class="colorBack">{{ item.Count }}{{ item.Unit }}</div>
            </div>
            <div class="colorBack">
              用法用量：{{ item.Usage }}，{{ item.Frequency }}
            </div>
          </div>
        </div>
        <!-- 中药 -->
        <div v-if="_deptCode">
          <div v-for="(item, i) in inquiryInfo.DrugsList" :key="i">
            <div class="flex_d">
              <!-- <div class="colorBack">{{ item.Name }}</div>
              <div class="colorBack">{{ item.Specs }}</div>
              <div class="colorBack">{{ item.Count }}{{ item.Unit }}</div> -->

              <div
                class="colorBack flex_d_item"
                v-for="uitem in inquiryInfo.useCNDrugsList"
                :key="uitem.Id"
              >
                {{ uitem.Name }}{{ uitem.Count }}{{ uitem.Unit }}
              </div>
            </div>
            <div class="colorBack">
              用法用量：{{ item.Usage }}，{{ item.Frequency }}
            </div>
             <div class="colorBack"> 总量：{{ item.Count}}{{ item.Unit}}</div>
          </div>
        </div>
      </div>
      <div class="blank margin-left">
        <span class="colorBack">以下空白</span>
        <div class="oksize colorBack" v-if="inquiryInfo.AuditStampUrl">
          <img :src="inquiryInfo.AuditStampUrl" alt width="134" />
        </div>
      </div>
    </div>
    <div class="posionInfo">
      <div class="flex1 mtb">
        <!-- 医师 -->
        <div class="flex2 widthStr3">
          <div class="lableStr colorBack">医师：</div>
          <div class="name tonSize">
            <img
              v-if="
                inquiryInfo.DoctorNameUrl &&
                inquiryInfo.DoctorNameUrl.length > 0
              "
              :src="inquiryInfo.DoctorNameUrl"
              width="70"
              height="25"
            />
            <img v-else class="visibility" width="70" height="25" />
          </div>
        </div>
        <!-- 药师 -->
        <div class="flex2 widthStr3">
          <div class="lableStr colorBack">药师：</div>
          <div class="name tonSize">
            <img
              v-if="
                inquiryInfo.HospPharNameUrl &&
                inquiryInfo.HospPharNameUrl.length > 0
              "
              :src="inquiryInfo.HospPharNameUrl"
              width="70"
              height="25"
            />
            <img v-else class="visibility" width="70" height="25" />
          </div>
        </div>
        <!-- 药品金额 -->
        <!-- <div class="flex2 widthStr4">
          <div class="lableStr colorBack">调配药师/士：</div>
          <div class="name tonSize">
            <img
              v-if="
                inquiryInfo.PharDispensingNameUrl &&
                inquiryInfo.PharDispensingNameUrl.length > 0
              "
              :src="inquiryInfo.PharDispensingNameUrl"
              width="70"
              height="25"
            />
            <img v-else class="visibility" width="70" height="25" />
          </div>
        </div> -->
        <div class="flex1 widthStr3">
          <div class="lableStr colorBack">药品金额：</div>
          <div class="name tonSize">
            <img width="70" height="25" class="visibility" />
          </div>
        </div>
      </div>
      <div class="flex1 mtb">
        <div class="widthStr3">
          <div class="flex1">
            <div class="lableStr colorBack">审核药师：</div>
            <div class="name tonSize">
              <img
                v-if="
                  inquiryInfo.PharAuditNameUrl &&
                  inquiryInfo.PharAuditNameUrl.length > 0
                "
                :src="inquiryInfo.PharAuditNameUrl"
                width="70"
                height="25"
              />
              <img v-else class="visibility" width="70" height="25" />
            </div>
          </div>
        </div>
        <div class="flex2 widthStr3">
          <div class="lableStr colorBack">调配药师/士：</div>
          <div class="name tonSize">
            <img
              v-if="
                inquiryInfo.PharDispensingNameUrl &&
                inquiryInfo.PharDispensingNameUrl.length > 0
              "
              :src="inquiryInfo.PharDispensingNameUrl"
              width="70"
              height="25"
            />
            <img v-else class="visibility" width="70" height="25" />
          </div>
        </div>
        <div class="widthStr3 flex2">
          <div class="lableStr colorBack">复核/发药药师：</div>
          <div class="name tonSize">
            <img
              v-if="
                inquiryInfo.PharReviewNameUrl &&
                inquiryInfo.PharReviewNameUrl.length > 0
              "
              :src="inquiryInfo.PharReviewNameUrl"
              width="80"
              height="25"
            />
            <img v-else class="visibility" width="70" height="25" />
          </div>
        </div>
      </div>
    </div>
    <div class="data">
      <span class="colorBack">开具日期：</span>
      <span class="heng colorBack">{{ inquiryInfo.ExpiredTime }}</span>
    </div>
    <div class="explain">
      <span class="colorBack">
        <span style="margin-right: 5px">本处方仅限患者在</span>
        {{ inquiryInfo.CompanyName }}
        <span style="margin-left: 5px">使用</span>
      </span>
      <img
        v-if="inquiryInfo.StampType == 1"
        class="imgStr"
        :src="inquiryInfo.HospitalStampUrl"
        alt
      />
      <img
        v-if="inquiryInfo.StampType == 2"
        class="imgStr_yuang"
        :src="inquiryInfo.HospitalStampUrl"
        alt
      />
    </div>
    <div>
      <span class="colorBack"
        >注意：医师处方仅开具{{
          inquiryInfo.ValidDay
        }}日有效（医师注明除外）</span
      >
    </div>
  </div>
</template>

<script>
import { GetPCOrderData } from "@/utils/api.js";
import "@/utils/jquery.jqprint-0.3";
export default {
  components: {},
  props: {
    InquiryId: {
      type: String,
      default: false,
    },
  },
  computed: {
    _deptCode: {
      get: function () {
        let code = false; //是否是中药方
        if (JSON.stringify(this.inquiryInfo) != "[]") {
          if (
            this.inquiryInfo.CNDrugsType &&
            this.inquiryInfo.CNDrugsType == 3
          ) {
            code = true;
          }
        }
        return code;
      },
    },
  },
  data() {
    return {
      inquiryInfo: [],
      sex: [],
      appMobilePhone: "123",
    };
  },
  methods: {
    getData() {
      let param = {
        LoInquiryId: this.InquiryId,
      };
      // const msg = this.$Message.loading({
      //   content: "获取数据中",
      //   duration: 0
      // });
      GetPCOrderData(param).then((res) => {
        // setTimeout(msg, 17);
        if (res.code == 1) {
          this.inquiryInfo = res.data;
          this.sex[0] = res.data.Sex == 2 ? "女" : "男";
          console.log(this.sex);
          this.appMobilePhone = res.data.DoctorName;

          this.$emit("afterPrint");
        } else {
          this.$Message.error("数据获取失败，请重试");
          this.$emit("beforPrint");
        }
      });
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.getData();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  deactivated() {},
};
</script>

<style lang="scss" scoped>
.domePrint {
  text-align: left;
  background: #ffffff;
  padding: 20px;
  width: 700px;
  height: 1000px;
  margin: auto;
  .rp {
    font-size: 30px;
    color: black;
    font-weight: bold;
  }
  .visibility {
    visibility: hidden;
  }
  .titleColor {
    color: black;
    font-size: 14px;
  }
  .colorBack {
    color: black;
    font-size: 18px;
  }
  .flex_d {
    width: 700px;
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
  }
  .flex_d_item {
    flex: 0 0 33%;
  }
  .margin-left {
    margin-left: 20px;
    // margin-right: 20px;
  }
  .data {
    padding: 8px 0px;
    .heng {
      border-bottom: 1px solid black;
    }
  }
  .widthStr280 {
    width: 280px;
  }
  .widthStr340 {
    width: 340px;
  }
  .widthStr {
    width: 300px;
  }
  .widthStr1 {
    width: 322px;
  }
  .widthStr2 {
    width: 280px;
  }
  .widthStr3 {
    width: 200px;
  }
  .widthStr4 {
    width: 250px;
  }
  .m-r {
    margin-right: 10px;
  }
  .explain {
    padding-bottom: 5px;
    border-bottom: 1px solid black;
    font-size: 15px;
    padding-left: 5px;
    position: relative;
    .imgStr_yuang {
      max-width: 160px;
      position: absolute;
      top: -80px;
      right: 70px;
    }

    .imgStr {
      max-width: 250px;
      position: absolute;
      top: -80px;
      right: 0px;
    }
  }
  .drugInfo {
    padding-bottom: 15px;
    border-bottom: 1px solid black;
    position: relative;
    .blank {
      border-top: 1px solid black;
      width: 30%;
      margin-top: 15px;
      padding: 5px;
      text-align: center;
      margin-bottom: 100px;
      .oksize {
        position: absolute;
        right: 100px;
        bottom: 20px;
        .okName {
          position: absolute;
          top: 15px;
          left: 50px;
          color: red;
          font-weight: bold;
        }
        .okData {
          position: absolute;
          bottom: 16px;
          left: 30px;
          color: red;
          font-weight: bold;
        }
      }
    }
  }
  .posionInfo_space {
    padding-bottom: 15px;
    border-bottom: 1px solid black;
  }
  .posionInfo {
    .mtb {
      padding-top: 10px;
    }
    .lableStr {
      width: auto;
      white-space: nowrap;
    }

    .name {
      width: 100%;
      border-bottom: 1px solid black;
    }
    .tonSize {
      width: 100%;
    }
    .age {
      width: 100%;
      border-bottom: 1px solid black;
    }

    .lastTonSize {
      width: 200px;
    }
  }
  .payOff {
    display: flex;
    justify-content: space-between;
    justify-items: start;
    align-items: flex-end;
    border-bottom: 1px solid black;
    padding-bottom: 5px;
  }
  .payOff_item {
    display: flex;
    justify-items: start;
    align-items: flex-end;
    // border-bottom: 1px solid black;
    // padding-bottom: 5px;
  }
  .register {
    font-size: 12px;
    color: black;
  }
  .title {
    margin: 30px 0 10px 0;
    text-align: center;
    position: relative;
  }
  .ordinary {
    position: absolute;
    top: 0;
    right: 20px;
    font-size: 12px;
    border: 1px solid black;
    padding: 3px 5px;
    border-radius: 5px;
    .putong {
      width: 100%;
      text-align: justify;
      text-align-last: justify;
    }
  }
  .bianju {
    line-height: 80px;
  }
  .hospitalName {
    font-size: 23px;
    font-weight: bold;
  }
  .hospitalOpen {
    font-size: 29px;
    font-weight: bold;
  }
}
.isChildBackground {
  background: #c9fee0;
}
</style>